// =============================================================================
// src/theme/tokens.ts — FREEEMAN デザイントークン正本 (2026-07-05 UI刷新 P0)
//
//   council 6_ux_architect §2.2 準拠。好評の JournalReviewPage L44-52 の
//   パレットC実装値を単一ファイルへ昇格したもの。AppShell・新規ページは
//   必ずここから import する (ページ内 `const S = {}` への新規色定義は禁止)。
// =============================================================================

// ---- 色 (パレットC) ---------------------------------------------------------
export const C = {
  ground: '#edf1f5',     // ページ地
  surface: '#ffffff',    // シート/カード面
  ink: '#1d2a3a',        // 本文
  sub: '#647386',        // 補助文字
  line: '#d9e0e7',       // 通常罫線
  lineDark: '#bdc8d3',   // 区画罫線
  navy: '#203a57',       // ヘッダ・主ボタン・左レール
  navy2: '#2c557c',      // navy の hover / セカンダリ
  blueTint: '#f0f6ff',   // 借方(debit)面 / アクティブ面
  blueLine: '#b9d2ed',   // 借方 罫線
  orangeTint: '#fff7ee', // 貸方(credit)面
  orangeLine: '#ecd2ae', // 貸方 罫線
  good: '#267a62', goodBg: '#edf8f4',
  warn: '#a46a12', warnBg: '#fdf3e3',
  danger: '#b3261e', dangerBg: '#fdecea',
} as const;

// ---- 字 ---------------------------------------------------------------------
export const FONT = '"Hiragino Sans","Yu Gothic UI","Meiryo",-apple-system,"Segoe UI",sans-serif';
// 金額・ID・日付は NUM + fontVariantNumeric:'tabular-nums' を必須とする
export const NUM = '"SFMono-Regular",Consolas,"Liberation Mono",Menlo,monospace';

// フォント階層 (px)。この5段以外を増やさない: 19 画面タイトル / 15 見出し /
// 13 本文 / 12 補助 / 11 ラベル
export const FS = { title: 19, head: 15, body: 13, sub: 12, label: 11 } as const;

// ---- 余白 (4刻み) -------------------------------------------------------------
export const SP = { x1: 4, x2: 8, x3: 12, x4: 16, x5: 20, x6: 24 } as const;

// ---- 角丸 (3種のみ: バッジ3 / 表・入力5 / シート10) ---------------------------
export const RADIUS = { badge: 3, panel: 5, sheet: 10 } as const;

// ---- 影 (1種のみ) -------------------------------------------------------------
export const SHADOW = { sheet: '0 9px 22px rgba(33,52,74,.08)' } as const;

// ---- z階層 --------------------------------------------------------------------
export const Z = { rail: 70, dock: 80, drawer: 90, toast: 100 } as const;
